import { atom } from "recoil";

export const AtomVideoSocket = atom<string | null | undefined>({
  key: "AtomVideoSocket",
  default: undefined,
});

export const AtomVideoErrors = atom<string>({
  key: "AtomVideoError",
  default: "",
});
